module.exports = __webpack_public_path__ + "img/dieindustrie_steiermark_logo_blau.994c1c11.png";